import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1, grey4, grey8 } from 'approot/shared/styles/colours.style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import { RoundIconButtonStyled } from 'approot/shared/round-icon-button/round-icon-button.style';

export const ActionsMenuContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 0 ${rem(spacing16)} 0;

  ${RoundIconButtonStyled} {
    margin: 0 ${rem(1)};
    svg {
      stroke: ${grey8};
    }
  }
`;

export const ActionsMenu = styled.div`
  background-color: ${grey1};
  border: 1px solid ${grey4};
  border-radius: ${rem(72)};
  display: flex;

  ${RoundIconButtonStyled}:last-of-type {
    margin: 0 0 0 ${rem(1)};
  }
  ${RoundIconButtonStyled}:first-of-type {
    margin: 0 ${rem(1)} 0 0;
  }
  ${RoundIconButtonStyled}:only-of-type {
    margin: 0;
  }
`;
